import Logo from "./Logo";
import Navbar from "./Navbar/Navbar";
import HeaderConfig from "./HeaderConfig";
import React, { useEffect, useState } from "react";
import navbarData from "../../data/Navbar/navbar.json";
import { GiHamburgerMenu } from "react-icons/gi";
import { ImCross } from "react-icons/im";
import { Link } from "react-router-dom";

const Header = () => {
  const [isSticky, setIsSticky] = useState(false);
  const [open, setOpen] = useState(false);

  const sticky = () => {
    const scrollTop = window.scrollY;
    scrollTop >= 250 ? setIsSticky(true) : setIsSticky(false);
  };

  useEffect(() => {
    window.addEventListener("scroll", sticky);

    return () => {
      window.removeEventListener("scroll", sticky);
    };
  }, []);

  return (
    <header className={`header-area ${isSticky ? "sticky" : "not-sticky"}`}>

      <div className="container">
        <div className="row align-items-center, header">
          <div className="col-5 col-lg-1 ">
            <Logo />
          </div>

          <div className="col-lg-7 d-none d-lg-block">
            <div className="navigation-area mt-lg-3">
              <div className="nav-menu">
                <Navbar />
              </div>
            </div>
          </div>
          {/* 
          <div className="col-7 col-lg-3">
            <HeaderConfig />
          </div> */}
        </div>
      </div>
      {/* <div className="appointment" style={{ textAlign: "end" }}>
        <Link to="/BookAppointmentCountry">
          <button
            className="btn-cog"
            style={{
              marginRight: "75px",
              background: "white",
              padding: "7px",
              borderRadius: "5px",
            }}
          >
            BOOK AN APPOINTMENT
          </button>
        </Link>
      </div> */}
       {/* nav menu for mobile view */}
      
       <div className="ham-icon" onClick={() => setOpen(!open)}>
          {open ? <ImCross size={"20px"} /> : <GiHamburgerMenu size={"25px"} />}
        </div>
    

      {open && (
        <nav className="mobile-nav-menu">
              {
           navbarData.map(item => (
            <li key={item.id}
                className={item.subMenu || item.megaMenu ? 'has-submenu' : ''}
            >
                <Link to={`${process.env.PUBLIC_URL + item.link}`}>{item.title}</Link>
                {(() => {
                    if (item.subMenu) {
                        return (
                            <ul className="submenu-nav">
                                {
                                    item.subMenu.map((subItem, index) => {
                                        return <li key={index}><Link to={`${process.env.PUBLIC_URL + subItem.link}`}>{subItem.title}</Link></li>
                                    })
                                }
                            </ul>
                        )
                    }

                    if (item.megaMenu) {
                        return (
                            <ul className="submenu-nav submenu-nav-mega">
                                {
                                    item.megaMenu.map((megaItem, indx) => (
                                        <li key={indx} className="mega-menu-item"><Link to={megaItem.link}>{megaItem.title}</Link>
                                            <ul>
                                                {
                                                    megaItem.lists.map((listItem, idx) => {
                                                        return <li key={idx}><Link to={`${process.env.PUBLIC_URL + listItem.link}`}>{listItem.title}</Link></li>
                                                    })
                                                }
                                            </ul>
                                        </li>
                                    ))
                                }
                            </ul>
                        )
                    }
                })()}
            </li>



        ))

     }
        
          
        </nav>
      )}
    </header>
  );
};

export default Header;
